var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1047 0.503889C10.3264 0.153379 10.7595 -0.0423206 11.2026 0.00774943L11.7048 0.0644694C14.4347 0.372859 16.1953 2.83353 15.3862 5.20993L14.7767 6.99999H15.5714C18.4899 6.99999 20.6096 9.5079 19.8416 12.0525L18.3328 17.0525C17.8076 18.7927 16.0585 20 14.0626 20H3.3197C1.48635 20 2.21317 18.6568 2.21317 17L2.21317 13.5L2.00011 9.5C2.00011 7.8431 1.48635 6.99999 3.3197 6.99999H5.53276C5.81993 6.99999 6.08508 6.86094 6.22756 6.63561L10.1047 0.503889ZM7.74583 18H14.0626C15.0605 18 15.935 17.3964 16.1976 16.5262L17.7066 11.5262C18.0906 10.2539 17.0307 9 15.5714 9H13.2785C12.9274 9 12.597 8.8494 12.3884 8.5941C12.1798 8.3388 12.1176 8.0092 12.2209 7.70591L13.271 4.62175C13.6529 3.49984 12.8894 2.34036 11.654 2.08468L8.14905 7.62789C7.80359 8.1742 7.2666 8.5859 6.6393 8.8098V17C6.6393 17.5523 7.13471 18 7.74583 18ZM4.42623 9V13V17C4.42623 17.3506 4.49279 17.6872 4.61513 18H3.3197C2.70859 18 2.21317 17.5523 2.21317 17L2.21317 13.5V10C2.21317 9.5 2.70859 9 3.3197 9H4.42623Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.26baafe824eab386b1dc30e6aee24543.svg";
export { ForwardRef as ReactComponent };